import { render } from "./UsualOvertimePay.vue?vue&type=template&id=4c18a1b2&scoped=true"
import script from "./UsualOvertimePay.vue?vue&type=script&lang=js"
export * from "./UsualOvertimePay.vue?vue&type=script&lang=js"

import "./UsualOvertimePay.vue?vue&type=style&index=0&id=4c18a1b2&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c18a1b2"]])

export default __exports__